import React from "react";
import AspectRatioContainer from "../../../services/Utils/AspectRatioContainer";
import * as AssetManagerTypes from "../AssetManager.types";
import IAsset from "../../../models/IAsset";
import { ReactComponent as PdfPlaceholder } from "../../../assets/icons/AssetManager/uploading-file-pdf-icon.svg";
function AssetLibraryDetailedView(props: any) {
  const handleAssetClick = (asset: IAsset) => (e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
    (props.AssetManagerDispatch as AssetManagerTypes.Dispatch<IAsset>)({
      type: "SELECT_ASSET",
      payload: asset,
    });
  const isSelected = (el: any) => {
    return el.assetVersionId === props.selectedAsset.assetId;
  };

  return (
    <div className="assetLibrary-detailView-container">
      <div className="assetLibrary-detailView-assetsContainer">
        {props.data.map((assetInView: any, index: number) => {
          const selected: string = isSelected(assetInView) ? "selected" : "";
          if (index > 5) return <></>;
          return (
            <div
              key={"aldvks" + index}
              className="assetLibrary-detailView-singleAsset-container-border"
              style={
                isSelected(assetInView)
                  ? {
                      background: "var(--cpat-green-hover)",
                      color: "var(--buttons-color)",
                      fontWeight: 700,
                    }
                  : {}
              }
            >
              <div
                className={`assetLibrary-detailView-singleAsset-container ${selected}`}
                onClick={handleAssetClick(assetInView)}
              >
                <div title={assetInView.name} className="detailView-singleAsset-name">
                  <div style={isSelected(assetInView) ? { fontWeight: 700 } : {}}>
                    Name: <p style={isSelected(assetInView) ? { fontWeight: 700 } : {}}>{assetInView.name}</p>
                  </div>
                </div>
                <div title={assetInView.description} className="detailView-singleAsset-description">
                  <div style={isSelected(assetInView) ? { fontWeight: 700 } : {}}>
                    Description: <p>{assetInView.description}</p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="assetLibrary-detailView-viewport">
        {props.typeMode === 4 && (
          <AspectRatioContainer
            height={100}
            width={100}
            src={props.selectedAsset.blobPath}
            additionalStyle={{ position: "absolute" }}
            onLoadedImage={() => {}}
          />
        )}
        {props.typeMode === 7 && (
          // <embed
          //   // sandbox="true"
          //   //the pdf will NOT work if the content-type (MIME) headers of the pdf are "octet-stream"
          //   height="100%"
          //   width="100%"
          //   type="application/pdf, application/octet-stream"
          //   itemType="application/pdf"
          //   src={'/api/Asset/' + props.selectedAsset.blobPath}
          //   ></embed>
          <PdfPlaceholder />
        )}
        {props.typeMode === 8 && (
          <video
            src={"/api/Asset/" + props.selectedAsset.blobPath}
            width="100%"
            height="100%"
            controls={true}
            autoPlay={false}
          />
        )}
        {props.typeMode === 10 && (
          <React.Fragment>
            <iframe style={{ display: "none" }} src="/REF_API_FAKE_1484_11.html" name="API_1484_11" />
            <iframe
              src={"../../api/Asset/" + props.selectedAsset.blobPath + "/index.html"}
              width="100%"
              height="56.25%"
            />
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

export default AssetLibraryDetailedView;
